import { render, staticRenderFns } from "./TahsilatList.vue?vue&type=template&id=4e210046&scoped=true"
import script from "./TahsilatList.vue?vue&type=script&lang=ts"
export * from "./TahsilatList.vue?vue&type=script&lang=ts"
import style0 from "./TahsilatList.vue?vue&type=style&index=0&id=4e210046&prod&lang=css"
import style1 from "./TahsilatList.vue?vue&type=style&index=1&id=4e210046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e210046",
  null
  
)

export default component.exports